export default __webpack_public_path__ + "static/mail-873822a256de1e512cdec03a6dc519c5.png";